export default __webpack_public_path__ + "static/media/salesOrderReport.45a75471.svg";